<div class="header"> Add Function Menu</div>
<br>
<div class="text-center">
    <mat-form-field appearance="outline">
        <mat-label>Function Name</mat-label>
        <input matInput [(ngModel)]="functionName" placeholder="Enter Function Name">
    </mat-form-field>
    <br>
  <mat-form-field appearance="outline" >

    <mat-label>Group Name</mat-label>
    <input matInput [(ngModel)]="groupName" placeholder="Enter Menu Group">
  </mat-form-field>
  <br>
  <div class="checkboxes">
    <mat-checkbox [(ngModel)]="addToAllUsersPermissions">Add to all users</mat-checkbox>
    <br>
    <mat-checkbox [(ngModel)]="addToAllProfiles">Add to all profiles</mat-checkbox>
  </div>
  <br>
    <button mat-raised-button color="primary" (click)="addFunction()"
      [disabled]="!functionName.trim() || !groupName.trim() || isLoading">Add Function</button>
</div>
<!-- Loader Spinner (only visible while loading) -->
<div class="spinner-container" *ngIf="isLoading">
  <mat-spinner diameter="60"></mat-spinner>
</div>
